module.exports = __webpack_public_path__ + "img/IconTriangleDown.8ce2015b.svg";